const REASONS = {
  forbidden: 'it already has a task or is closed',
  owner_has_no_access: 'that person does not have access to its building',
  not_found: 'it no longer exists',
}

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`

export const bulkUpdateMessage = (result, requested) => {
  const updated = Number(result?.updated ?? 0)
  const skipped = Array.isArray(result?.skipped) ? result.skipped : []
  const unchanged = Math.max(0, Number(requested || 0) - updated - skipped.length)
  const parts = [`${plural(updated, 'remedial')} updated.`]
  const byReason = skipped.reduce((acc, item) => ({ ...acc, [item.reason]: (acc[item.reason] || 0) + 1 }), {})
  Object.entries(byReason).forEach(([reason, count]) => {
    parts.push(`${count} not changed because ${REASONS[reason] || 'it could not be changed'}.`)
  })
  if (unchanged > 0) parts.push(`${unchanged} already had that value.`)
  const tone = skipped.length ? (updated ? 'warning' : 'error') : 'success'
  return { text: parts.join(' '), tone }
}

const CONVERT_REASONS = {
  not_convertible: ['it already has a task or is closed', 'they already have a task or are closed'],
  forbidden_action: ['you do not have permission to change it', 'you do not have permission to change them'],
  forbidden_task_create: ['tasks cannot be created for its building', 'tasks cannot be created for their buildings'],
  create_failed: ['something went wrong creating its task', 'something went wrong creating their tasks'],
}

const FALLBACK_REASON = ['it could not be changed', 'they could not be changed']

const toneFor = (done, skipped) => (skipped ? (done ? 'warning' : 'error') : 'success')

export const bulkConvertMessage = result => {
  const converted = Array.isArray(result?.convertedIds) ? result.convertedIds.length : Number(result?.convertedCount ?? 0)
  const skipped = Array.isArray(result?.skipped) ? result.skipped : []
  const parts = [`${plural(converted, 'task')} created from the selected remedials.`]
  const byReason = skipped.reduce((acc, item) => ({ ...acc, [item.reason]: (acc[item.reason] || 0) + 1 }), {})
  Object.entries(byReason).forEach(([reason, count]) => {
    const [one, many] = CONVERT_REASONS[reason] || FALLBACK_REASON
    parts.push(`No task was created for ${count} because ${count === 1 ? one : many}.`)
  })
  return { text: parts.join(' '), tone: toneFor(converted, skipped.length) }
}

export const bulkDismissMessage = result => {
  const dismissed = Array.isArray(result?.dismissedIds) ? result.dismissedIds.length : Number(result?.dismissedCount ?? 0)
  const skipped = Array.isArray(result?.skippedIds) ? result.skippedIds.length : 0
  const parts = [`${plural(dismissed, 'AI find')} removed as not a real issue.`]
  if (skipped === 1) parts.push('1 was not removed because it is no longer awaiting review or you do not have permission.')
  if (skipped > 1) parts.push(`${skipped} were not removed because they are no longer awaiting review or you do not have permission.`)
  return { text: parts.join(' '), tone: toneFor(dismissed, skipped) }
}

export const firstErrorMessage = (payload, fallback) => {
  const errors = payload?.errors && typeof payload.errors === 'object' ? Object.values(payload.errors).flat() : []
  const first = errors.find(message => typeof message === 'string' && message.trim())
  if (first) return first
  const message = payload?.error || payload?.message
  if (message && !/server error|given data was invalid/i.test(message)) return message
  return fallback
}
